import { ArticleParagraph2 } from '@cian/ui-kit';

import { FC } from 'react';

import { CoworkingPlacementApplicationModal } from 'shared/components/CoworkingPlacementApplicationModal';

import { usePlacementApplicationBoundActions } from './internal/hooks/usePlacementApplicationBoundActions';

import * as styles from './PlacementApplication.css';

export const PlacementApplication: FC = () => {
  const boundActions = usePlacementApplicationBoundActions();

  return (
    <CoworkingPlacementApplicationModal>
      {modalVisibilityState => {
        const handleButtonClick = (): void => {
          boundActions.trackPlaceOpen();

          modalVisibilityState.setTrue();
        };

        return (
          <button
            className={styles['placement-application-button']}
            data-testid="placement-application-button"
            type="button"
            onClick={handleButtonClick}
          >
            <ArticleParagraph2 as="span" color="primary_100" fontWeight="normal">
              Хочу разместить свой коворкинг
            </ArticleParagraph2>
          </button>
        );
      }}
    </CoworkingPlacementApplicationModal>
  );
};

PlacementApplication.displayName = 'PlacementApplication';
